import gql from 'graphql-tag';
import * as Cookies from 'es-cookie';

export const SEND_SMS_MUTATION = gql`
  mutation($params: SendSMS) {
    sendSMS(params: $params)
  }
`;

export const GET_SMS_TEMPLATES = gql`
  query($institute_id: Int!, $branch_id: Int) {
    getSMSTemplates(institute_id: $institute_id, branch_id: $branch_id) {
      template_name
      template_id
      template_text
    }
  }
`;

export const SMS_TEMPLATES = {
  TEST_ASSIGNED: (data) => ({
    message: `Dear ${data.student_name}, your Admission Test login details: Link: ${window.location.origin}/admission-test | User: ${data.username} | Pass: ${data.password}. Best of luck!`,
    template_id: "1607100000000025404" // Fallback to default, user might provide specific ones later
  }),
  ADMISSION_CONFIRMED: (data) => ({
    message: `Congratulations ${data.student_name}! Your admission is confirmed at ${data.institute_name || 'our institute'}. We look forward to welcome you.`,
    template_id: "1607100000000025404"
  }),
  MANUAL: (message) => ({
    message,
    template_id: "1607100000000025404"
  })
};

/**
 * Trigger SMS helper
 * @param {import('apollo-client').default} client - Apollo client
 * @param {Object} options - { student, type, customData }
 */
export const triggerSms = async (client, { student, type, customData = {} }) => {
  if (!student || !student.student_mobile) {
    console.warn("SMS trigger aborted: No student or mobile number.");
    return false;
  }

  const mobile = (student.student_mobile || "").replace(/\D/g, "");
  if (mobile.length < 10) {
    console.warn("SMS trigger aborted: Invalid mobile number.");
    return false;
  }

  let smsData;
  if (type === 'ASSIGNED') {
    smsData = SMS_TEMPLATES.TEST_ASSIGNED({
      student_name: student.student_name,
      username: customData.username || '—',
      password: customData.password || '—'
    });
  } else if (type === 'ADMITTED') {
    smsData = SMS_TEMPLATES.ADMISSION_CONFIRMED({
      student_name: student.student_name,
      institute_name: Cookies.get('institutionname')
    });
  } else if (type === 'MANUAL') {
    smsData = SMS_TEMPLATES.MANUAL(customData.message || '');
  }

  if (!smsData || !smsData.message) return false;

  try {
    const result = await client.mutate({
      mutation: SEND_SMS_MUTATION,
      variables: {
        params: {
          institute_id: parseInt(Cookies.get('institutionid')),
          branch_id: parseInt(student.branch_id || Cookies.get('branchid')),
          template_details: [
            {
              message: smsData.message,
              template_id: customData.template_id || smsData.template_id,
              mobile: mobile
            }
          ]
        }
      }
    });
    return result.data.sendSMS;
  } catch (err) {
    console.error("Failed to trigger SMS mutation:", err);
    return false;
  }
};
